import {
  LuActivity,
  LuBarChartBig,
  LuShapes,
  LuSquareSlash,
  LuStethoscope,
  LuStickyNote,
  LuTablets,
  LuTrendingUp,
  LuUserSquare2,
  LuWarehouse,
  LuWebhook,
  LuUser,
  LuUsers,
} from "react-icons/lu";
import { MenuType } from "../types/menu.type";
import { ContainerOwnProps } from "@mui/material";

const HEADER_HEIGHT: string = "60px";
const SIDEBAR_MINWIDTH: string = "72px";
const SIDEBAR_MAXWIDTH: string = "260px";
const MOBILE_CONTAINER: ContainerOwnProps["maxWidth"] = "sm";
const COLORS: { max: string; min: string; near: string } = {
  max: "#fa0000",
  min: "#08991b",
  near: "#ff8e00",
};

const MENUS: MenuType[] = [
  {
    subheader: "Dữ liệu đầu vào",
    items: [
      {
        text: "Thuốc",
        Icon: LuShapes,
        path: "/list/cr_thuoc",
        module: "cr_thuoc",
      },
      {
        text: "ID Thuốc",
        Icon: LuShapes,
        path: "/list/danhmucidthuoc",
        module: "danhmucidthuoc",
      },
      {
        text: "Nhu cầu sử dụng thuốc",
        Icon: LuShapes,
        path: "/list/ncsdthuoc",
        module: "ncsdthuoc",
      },
      {
        text: "Dự trù thuốc mới",
        Icon: LuShapes,
        path: "/list/dtthuoc",
        module: "dtthuoc",
      },
      {
        text: "Vật tư y tế",
        Icon: LuStethoscope,
        path: "/list/cr_vtyt",
        module: "cr_vtyt",
      },
      {
        text: "Hóa chất",
        Icon: LuTablets,
        path: "/list/cr_hc",
        module: "cr_hc",
      },
    ],
  },
  {
    subheader: "Dữ liệu đầu ra",
    items: [
      {
        text: "BC truy xuất kết quả tìm kiếm",
        path: "/group/cr_thuoc",
        module: "cr_thuoc",
        Icon: LuBarChartBig,
      },
      {
        text: "BC kết quả tìm kiếm",
        path: "/list/fos_rpkeysearch",
        module: "fos_rpkeysearch",
        Icon: LuBarChartBig,
      },
      {
        text: "BC dự trù toàn bệnh viện",
        path: "/list/fos_rpdtthuoc",
        module: "fos_rpdtthuoc",
        Icon: LuBarChartBig,
      },
    ],
  },
  {
    subheader: "Quản lý trúng thầu",
    items: [
      {
        text: "KQTT thuốc",
        path: "/list/kqtt_thuoc",
        module: "kqtt_thuoc",
        Icon: LuShapes,
      },
      {
        text: "KQTT vật tư, hóa chất",
        path: "/list/cr_tt_vthc",
        module: "cr_tt_vthc",
        Icon: LuTablets,
      },
      {
        text: "Nhập kho TT",
        path: "/list/nk_tt",
        module: "nk_tt",
        Icon: LuStickyNote,
      },
      {
        text: "Xuất kho TT",
        path: "/list/xk_tt",
        module: "xk_tt",
        Icon: LuSquareSlash,
      },
      {
        text: "Báo cáo thực hiện TT",
        path: "/list/bc_tt",
        module: "bc_tt",
        Icon: LuTrendingUp,
      },
    ],
  },
  {
    subheader: "Quản lý đối tượng",
    items: [
      {
        text: "Chủ đầu tư",
        Icon: LuUserSquare2,
        path: "/list/customer",
        module: "customer",
      },
    ],
  },
  {
    subheader: "Danh mục chung",
    items: [
      {
        text: "Nhóm thuốc",
        Icon: LuTablets,
        path: "/list/cr_nhomthuoc",
        module: "cr_nhomthuoc",
      },
      {
        text: "Hoạt chất",
        Icon: LuActivity,
        path: "/list/cr_hoatchat",
        module: "cr_hoatchat",
      },
      {
        text: "Đường dùng",
        Icon: LuWebhook,
        path: "/list/cr_duongdung",
        module: "cr_duongdung",
      },
      {
        text: "Nước sản xuất",
        Icon: LuWarehouse,
        path: "/list/cr_nsx",
        module: "cr_nsx",
      },
    ],
  },
  {
    subheader: "Hệ thống",
    items: [
      {
        text: "Người sử dụng",
        path: "/list/participant",
        module: "participant",
        Icon: LuUser,
      },
      {
        text: "Nhóm người sử dụng",
        path: "/list/usergroup",
        module: "usergroup",
        Icon: LuUsers,
      },
    ],
  },
];

export {
  HEADER_HEIGHT,
  SIDEBAR_MINWIDTH,
  SIDEBAR_MAXWIDTH,
  MOBILE_CONTAINER,
  MENUS,
  COLORS,
};
